var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { attrs: { name: "query-sort-block" } },
        [
          _c("swb-query-sort-area", {
            ref: "query_model_ctrl",
            attrs: {
              confKey: _vm.confKey,
              configAuto: true,
              queryOnLoad: _vm.queryOnLoad,
              onConfigReady: _vm.onConfigReady,
              queryHandler: _vm.queryHandler
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _vm.checkActionPerm("create")
            ? _c(
                "div",
                {
                  staticClass: "swb-btn swb-btn-small",
                  on: {
                    click: function($event) {
                      _vm.goToNewPage()
                    }
                  }
                },
                [_vm._v("新增请购单\n            ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkActionPerm("saveBatch") && _vm.bizUnitLevel == 1
            ? _c(
                "div",
                {
                  staticClass: "swb-btn swb-btn-small",
                  on: {
                    click: function($event) {
                      _vm.goToNewPageForBatch()
                    }
                  }
                },
                [_c("span", [_vm._v("批量创建")])]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            {
              staticClass: "swb-btn swb-btn-small swb-btn-primary",
              on: {
                click: function($event) {
                  _vm.saveOrderList()
                }
              }
            },
            [_vm._v("生成订单")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small swb-btn-primary",
              on: { click: _vm.doExport }
            },
            [_vm._v("导出")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tab-container small base",
          attrs: { name: "tab-container" }
        },
        [
          _c("div", { staticClass: "tabs-nav" }, [
            _c(
              "ul",
              { staticClass: "head" },
              _vm._l(_vm.requireVoucherStateList, function(item) {
                return _c(
                  "li",
                  {
                    staticClass: "head-item",
                    class: { current: item.name == _vm.checkStateValue },
                    on: {
                      click: function($event) {
                        _vm.tabChange(item.name)
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(item.text))])]
                )
              })
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("swb-result-table", {
        ref: "result_table",
        attrs: {
          name: "result_table",
          btnColBaseCount: 2,
          btnColMoreTitle: "更多操作",
          confKey: _vm.confKey,
          configAuto: true,
          needPager: _vm.needPager,
          multiSelect: _vm.multiSelect,
          multiPageSelect: _vm.multiPageSelect,
          rowKeyPropName: _vm.rowKeyPropName,
          rowNoShow: _vm.rowNoShow,
          rowNoFixed: _vm.rowNoFixed,
          btnColName: _vm.btnColName,
          btnColTitle: _vm.btnColTitle,
          btnColWidth: _vm.btnColWidth,
          btnColFixed: _vm.btnColFixed,
          height: _vm.theTableHeight,
          pageNoChangeHandler: _vm.pageNoChangeHandler,
          rowDblClickHandler: _vm.rowDblClickHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-761aa378", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-761aa378","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/DeviceRequireVoucherManager.vue
// module id = 2911
// module chunks = 0